import { useCallback } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { LandingVideosSettingsEntity } from "../../Objects/Landing/LandingVideosSettingsEntity"
import { GetRequest } from "../../services/ApiClientService"

export const useGetLandingVideos = () => {
  const handleGetLandingVideos = useCallback(async () => {
    const response = await GetRequest<LandingVideosSettingsEntity>(API_ROUTES.LANDING.GET_VIDEOS)

    if (!response.success) {
      throw new Error(response.message || "Erro ao buscar vídeos da landing.")
    }

    return new LandingVideosSettingsEntity(response.data)
  }, [])

  return { handleGetLandingVideos }
}
